export const ADD_ITEM = "ADD_ITEM"
export const REMOVE_ITEM = "REMOVE_ITEM"
export const ADD_FAVOURITE_ITEM = "ADD_FAVOURITE_ITEM"
export const REMOVE_FAVOURITE_ITEM = "REMOVE_FAVOURITE_ITEM"
export const CHECKOUT = "CHECKOUT"
export const CLEAR = "CLEAR"
export const INITIALIZE_CART = "INITIALIZE_CART"
export const LOGOUT = "LOGOUT"
